/**
 * Spacing Design Tokens
 *
 * ⭐ MODIFY SPACING HERE
 * Change these values to update the entire app's spacing
 */

export const spacing = {
  // Base 4px scale
  0: '0',
  1: '0.25rem',   // 4px
  2: '0.5rem',    // 8px
  3: '0.75rem',   // 12px
  4: '1rem',      // 16px
  6: '1.5rem',    // 24px
  8: '2rem',      // 32px
  12: '3rem',     // 48px
  16: '4rem',     // 64px
  20: '5rem',     // 80px
  24: '6rem',     // 96px

  // Semantic spacing - CHANGE THESE for easy site-wide updates
  cardPadding: '1.5rem',         // 24px - CHANGE ME
  cardGap: '2rem',               // 32px - CHANGE ME
  sectionY: '5rem',              // 80px - CHANGE ME
  navHeight: '4rem',             // 64px - CHANGE ME
  containerPadding: {
    mobile: '1.5rem',            // 24px
    desktop: '4rem',             // 64px
  },
} as const;
